import { render, staticRenderFns } from "./Item18.vue?vue&type=template&id=bc9cdafe&scoped=true&"
import script from "./Item18.vue?vue&type=script&lang=js&"
export * from "./Item18.vue?vue&type=script&lang=js&"
import style0 from "./Item18.vue?vue&type=style&index=0&id=bc9cdafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9cdafe",
  null
  
)

export default component.exports